var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DeliveryOptionCardContent',_vm._g(_vm._b({attrs:{"option":_vm.option,"message-items":[
		{ icon: 'mdi-clock', text: this.option.data.openingHours },
		{ icon: 'mdi-phone', text: this.option.data.phone },
		{ icon: 'mdi-email', text: this.option.data.email } ],"show-to-address-line":""}},'DeliveryOptionCardContent',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }